if (!customElements.get('td-back-in-stock')) {
  class TdBackInStock extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-td-back-in-stock-trigger]');
      this.onTriggerClick = this.handleTriggerClick.bind(this);
      this.trigger?.addEventListener('click', this.onTriggerClick);
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.onTriggerClick);
    }

    handleTriggerClick(event) {
      if (this.dataset.tdBufferSoldOut !== 'true') return;

      event.preventDefault();
      window.setTimeout(() => this.showKlaviyoModal(), 0);
    }

    showKlaviyoModal(attempt = 0) {
      const modal = document.getElementById('klaviyo-bis-iframe');

      if (!modal) {
        if (attempt < 10) {
          window.setTimeout(() => this.showKlaviyoModal(attempt + 1), 100);
        }
        return;
      }

      modal.style.display = 'block';
      modal.contentDocument?.querySelector('#email')?.focus();
    }
  }

  customElements.define('td-back-in-stock', TdBackInStock);
}
